module.exports = "<div class=\"tooltip\">\n\t<!-- Icon -->\n\t<span class=\"icon\">\n\t\t<img src=\"{{ tooltipIcon }}\" alt=\"\">\n\t</span>\n\n\t<!-- Tip -->\n\t<div\n    class=\"tip\"\n    [ngClass]=\"{ 'dark-theme': tooltipTheme === 'dark-theme', 'right': !tooltipRightSide && !tooltipBottomSide, 'left': tooltipRightSide && !tooltipBottomSide,'bottom': tooltipBottomSide}\">\n\t\t{{ tooltipText | translate }} <a *ngIf=\"link\" [href]=\"linkRef\">{{ linkText }}</a>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tooltip/tooltip.component.html
// module id = ./src/app/shared/components/tooltip/tooltip.component.html
// module chunks = main